
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getCloudinaryTextData } from '../inputs/data/cloudinary-data';

class AddProfilePic extends React.Component {
  constructor(props) {
    super(props);
    this.state = { photoError: "", widget: null };
    this.onTransactableProfilePicUpload = this.onTransactableProfilePicUpload.bind(this);
    this.renderCloudinaryWidget = this.renderCloudinaryWidget.bind(this);
  }

  componentDidMount() {
    const locale = this.props.intl.locale;
    const profilePhotoPresets = {
      upload_preset: 'e6m9x7iz',
      show_powered_by: false,
      multiple: false,
      cropping: 'server',
      cropping_aspect_ratio: 1,
      mode: 'crop', gravity: 'custom',
      client_allowed_formats: ["jpg", "jpeg", "png"],
      sources: ['local'],
      theme: 'white',
      max_file_size: 8000000,
      max_image_width: 1000,
      max_image_height: 1000,
      showSkipCropButton: false,
      language: locale,
      text: { [locale]: getCloudinaryTextData(this.props.intl) }
    };
    cloudinary.setCloudName('peerspace-inc');
    const widget = cloudinary.createUploadWidget(profilePhotoPresets, function(error, result) {
      this.onTransactableProfilePicUpload(error, result);
    }.bind(this));
    this.setState({ widget });
  }

  onTransactableProfilePicUpload(err, result) {
    if (err) {
      this.setState({ photoError: 'Something went wrong.  Please try again.' });
    } else if ('success' === result.event) {
      const imgInfo = (result || {}).info || {};
      const newProfileURL = imgInfo.secure_url;
      const croppedProfileURL = newProfileURL.replace("upload/", "upload/c_crop,g_custom/");
      const user = {};
      user.avatar_url = croppedProfileURL;
      var usrStr = JSON.stringify(user);
      this.props.updateAction(this.props.user.SSOid, usrStr, this.props.callback);
    }
  }

  renderCloudinaryWidget(event) {
    event.preventDefault();
    this.state.widget.open();
  }

  render() {
    return (
      <div id="add-photo">
        <h3 className="text-center">
          <FormattedMessage id='shared_components.profile_pic.upload_your_photo' defaultMessage='Upload Your Profile Photo' />
        </h3>
        <div>
          <div id="profile-photo-area" className="col-sm-3 col-sm-offset-2">
            <div id="upload-photo-icon" onClick={this.renderCloudinaryWidget} className="text-center">
              <span className="ico ico-lg icon-user" />
            </div>
            <div id="profile-photo-display"></div>
            <div id="photo-error" className="text-center text-primary">{this.state.photoError}</div>
          </div>
          <div id="profile-photo-button" className="col-sm-6 text-xs-center text-sm-justify">
            <button tab-index="1" onClick={this.renderCloudinaryWidget} className="btn btn-md inverted-button-success btn-black">
              <span className="ico icon-add-photos" />
              <span>
                <FormattedMessage id='shared_components.profile_pic.upload_photo' defaultMessage='Upload Photo' />
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

AddProfilePic.propTypes = { intl: PropTypes.object };
export default injectIntl(AddProfilePic);
